var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"getMoreButton",staticClass:"moreItems moreToGet",staticStyle:{"padding-top":"5px"},on:{"click":_vm.raiseGetMore}},[_vm._v("\n  "+_vm._s(_vm.label)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }